import { useState } from "react";
import { updateUser } from '../../../shared/service';

const SaveChanges = ({prase, dataToSend, fetchUser, fetcher}) => {
    const [modal, setModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    
    const stateM = () => {
        setModal(!modal);
    }

    const stateEM = () => {
        setErrorModal(!errorModal);
    }

    async function fillUserInfo() {
        try {
          await updateUser(dataToSend);
          fetchUser();
          fetcher();
          stateM();
        } catch (error) {
          console.error('Ошибка при запросе к API:', error);
          stateEM();
        }
      }

    return <p>
      <button className="user-profile-save-btn" onClick={fillUserInfo}>{prase}</button>
      {modal && 
          <div className="modal-window">
            <div className="error-block"> 
              <div className="error-massage">
                <h1>Succsess!</h1>
                <p>Changes applied succsessfully</p>
                <button className="error-btn" onClick={stateM}>Close</button>
              </div>
            </div>
          </div>
      }
      {errorModal && 
      <div className="modal-window">
        <div className="error-block"> 
          <div className="error-massage">
            <h1>Error</h1>
            <p>Server is not responding</p>
            <button className="error-btn" onClick={stateEM}>Close</button>
          </div>
        </div>
      </div>}    
  </p>
}

export default SaveChanges;